import { useEffect, useState } from 'react';

export const DEF_WAIT_MS = 5;

export interface UseStable {
  cb: () => void;
  waitMs?: number;
}

/**
 * Runs a set of commands once the rendering loop has stabilized
 * for a set period of time.
 */
export const useStable = (args: UseStable) => {
  const { cb, waitMs = DEF_WAIT_MS } = args;
  const [locked, setLocked] = useState(false);
  useEffect(() => {
    if (!locked) {
      const timeoutId = setTimeout(() => {
        setLocked(true);
        cb();
      }, waitMs);
      return () => clearTimeout(timeoutId);
    }
  });
};
